import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import "components/subCategory/ManagementCategroy.scss";
import logo from "assets/images/logo/logo.png";
import { pathMaker } from "../../utils/helperFunctions";

const ManagementCategory = ({
  subCategory,
  subSelect,
  setSubSelect,
  selectCategory,
  changeCategoryURL,
}) => {
  const { id } = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  useEffect(() => {
    console.log("subCheck: ", subCategory);
  }, [subCategory]);

  return (
    <div className="d-flex subcategory-banner ">
      {id != 66 && (
        <div
          className={`subcategory-servic d-flex flex-column justify-content-center align-items-center ${
            subSelect == 0 && urlParams.get("sub") == null ? "selected" : ""
          }`}
          onClick={() => {
            subSelect != 0 && setSubSelect(0);

            changeCategoryURL(selectCategory?.hashtag?.id, "all-cat");
          }}
        >
          <div
            style={{ width: "90px" }}
            className="subcategory-title text-center font-14-400"
          >
            همه {selectCategory?.hashtag?.txt}
          </div>
        </div>
      )}

      {subCategory.length > 0 &&
        subCategory.map((item) => (
          <div
            className={`subcategory-servic d-flex flex-column justify-content-center align-items-center position-relative w-auto ${
              item.id == urlParams.get("sub") ? "selected" : ""
              // item.id == subSelect ? "selected" : ""
            }`}
            onClick={() => changeCategoryURL(item.id)}
          >
            <div className="subcategory-img">
              <img
                className="img"
                src={item.icon ? pathMaker(item.icon) : logo}
                alt={item.title}
                style={{ objectFit: "contain" }}
              />
            </div>
            <div className="subcategory-title text-dark"> {item.txt}</div>
            {/*{item.id == subSelect && <div className='subcategory-close position-absolute' onClick={() => handleCategoryClick("delete", index)}><AiOutlineClose size={16} /></div>}*/}
          </div>
        ))}
    </div>
  );
};

export default ManagementCategory;
